import { useSearchParams } from 'react-router-dom';
import { Mail, Building2, Handshake } from 'lucide-react';
import { ContactForm } from '@/components/ContactForm';
import type { ContactReason } from '@visiward/shared';

export function Contact() {
  const [params] = useSearchParams();
  const reasonParam = params.get('reason') as ContactReason | null;

  return (
    <div className="mx-auto max-w-5xl px-4 py-16 sm:px-6">
      <div className="grid gap-10 lg:grid-cols-2">
        <div>
          <h1 className="text-4xl font-bold tracking-tight text-text-primary">Contact us</h1>
          <p className="mt-4 text-text-secondary">
            Questions, partnership ideas, or interested in Advanced Analysis for your business or
            agency? Send us a note and we’ll get back to you.
          </p>
          <div className="mt-8 space-y-4">
            {[
              { icon: Mail, title: 'Support', body: 'Help with your account or an analysis.' },
              {
                icon: Building2,
                title: 'Advanced Analysis',
                body: 'Available for selected businesses and agencies.',
              },
              { icon: Handshake, title: 'Partnerships', body: 'Let’s explore working together.' },
            ].map((i) => (
              <div key={i.title} className="flex gap-3">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-accent-blue/10 text-accent-blue">
                  <i.icon size={18} />
                </span>
                <div>
                  <p className="text-sm font-semibold text-text-primary">{i.title}</p>
                  <p className="text-sm text-text-secondary">{i.body}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="panel p-6">
          <ContactForm defaultReason={reasonParam ?? undefined} />
        </div>
      </div>
    </div>
  );
}
